import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TenantService } from '.';

@Injectable({ providedIn: 'root' })
export class PublicUnauthGuard implements CanActivate {

    constructor(private tenantService: TenantService, private router: Router) { }

    canActivate(): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        return this.tenantService.getUnauthTenantInfo()
        .pipe(map((tenant) => 
            tenant.settings?.publicTopics === 'true' ? 
                this.router.createUrlTree(['/browse']) : 
                true));
    }
}
